import * as React from 'react';
import { twMerge } from 'tailwind-merge';

interface EyebrowProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'prefix'> {
  primary?: boolean;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

export const Eyebrow = React.forwardRef<HTMLDivElement, EyebrowProps>(
  ({ primary = false, prefix, suffix, children, className, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={twMerge(
          'font-mono text-[10.5px] font-medium tracking-[.12em] uppercase',
          primary ? 'text-primary-9' : 'text-text-3',
          className,
        )}
        {...rest}
      >
        {prefix && <span className="text-primary-9">{prefix}</span>}
        {children}
        {suffix}
      </div>
    );
  },
);

Eyebrow.displayName = 'Eyebrow';
